<template>
  <!--司法全景-->
  <div>
    <div style="margin-bottom:16px;">
      <a-row :gutter="16">
        <a-col :span="8">
          <dl class="countWrap">
            <dt class="iconBack"><img src="../img/user.png" alt="" /></dt>
            <dd>
              <h6>{{ this.judicialStatistics.zxzs }}</h6>
              <p>列入被执行人名单次数</p>
            </dd>
          </dl>
        </a-col>
        <a-col :span="8">
          <dl class="countWrap">
            <dt class="iconBack" style="background:#1E90FF">
              <img src="../img/bank.png" alt="" />
            </dt>
            <dd>
              <h6>{{ this.judicialStatistics.bdze }}</h6>
              <p>列入被执行标的总额</p>
            </dd>
          </dl>
        </a-col>
        <a-col :span="8">
          <dl class="countWrap">
            <dt class="iconBack" style="background:#48D1CC">
              <img src="../img/comparison.png" alt="" />
            </dt>
            <dd>
              <h6>{{ this.judicialStatistics.wlxrs }}</h6>
              <p>列入失信被执行人名单次数</p>
            </dd>
          </dl>
        </a-col>
      </a-row>
    </div>
    <div style="margin-bottom:16px;">
      <a-row :gutter="16">
        <a-col :span="12">
          <h4>涉案的案由所对应的案件个数</h4>
          <TableView
            :columns="columnsCaseNum"
            :data="caseNumOfCauseAction"
            :pagination="false"
            :loading="loading"
            :bordered="bordered"
            :rowKey="rowKey"
          ></TableView>
        </a-col>
        <a-col :span="12">
          <h4>案件地域分布</h4>
          <TableView
            :columns="columnsLawCase"
            :data="lawCaseDistribution"
            :pagination="false"
            :loading="loading"
            :bordered="bordered"
            :rowKey="rowKey"
          ></TableView>
        </a-col>
      </a-row>
    </div>
    <div style="margin-bottom:16px;">
      <chart
        :judicialStatistics="judicialStatistics"
        :caseNumOfCauseAction="caseNumOfCauseAction"
        :judicialStatisticsByYear="judicialStatisticsByYear"
        :lawCaseDistribution="lawCaseDistribution"
      />
    </div>
  </div>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
import { getPanorama } from './api.js'
import chart from './panorama/chart'
export default {
  components: { TableView, chart },
  data() {
    return {
      enterpriseName: '',
      judicialStatistics: {},
      caseNumOfCauseAction: [],
      judicialStatisticsByYear: [],
      lawCaseDistribution: [],
      rowKey: 'id',
      columnsCaseNum: [
        {
          title: '企业名称',
          dataIndex: 'company',
          key: 'company',
          width: '100px',
        },
        {
          title: '案由',
          dataIndex: 'causename',
          key: 'causename',
        },
        {
          title: '案件个数',
          dataIndex: 'ayzs',
          key: 'ayzs',
          width: '100px',
        },
      ],
      columnsLawCase: [
        {
          title: '企业名称',
          dataIndex: 'companyname',
          key: 'companyname',
        },
        {
          title: '区域',
          dataIndex: 'geo',
          key: 'geo',
        },
        {
          title: '案件个数',
          dataIndex: 'dqzs',
          key: 'dqzs',
        },
      ],
      loading: true,
      bordered: true,
    }
  },
  mounted() {
    const params = {
      enterpriseName: this.$store.getters['app/company'].name,
      // enterpriseName: '北京联想金服科技有限公司'
    }
    this._getPanorama(params)
  },
  methods: {
    async _getPanorama(params) {
      const {
        resultData: {
          judicialStatistics,
          caseNumOfCauseAction,
          judicialStatisticsByYear,
          lawCaseDistribution,
        },
      } = await getPanorama(params)
      this.loading = false
      this.judicialStatistics = judicialStatistics
      this.caseNumOfCauseAction = caseNumOfCauseAction
      this.judicialStatisticsByYear = judicialStatisticsByYear
      this.lawCaseDistribution = lawCaseDistribution
    },
  },
}
</script>
<style lang="less">
.countWrap {
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  background: #fff;
  dt {
    background: #ffc125;
    line-height: 111px;
    float: left;
    width: 20%;
    text-align: center;
  }
  dd {
    float: left;
    width: 80%;
    h6 {
      color: #ffc125;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 28px;
    }
    p {
      text-align: center;
      font-size: 16px;
    }
  }
}
</style>
